import { render, staticRenderFns } from "./PushSetting.vue?vue&type=template&id=0c508fd5&"
import script from "./PushSetting.vue?vue&type=script&lang=js&"
export * from "./PushSetting.vue?vue&type=script&lang=js&"
import style0 from "./PushSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VDivider,VProgressCircular,VSwitch})
